// Ürün tipleri
export const PRODUCT_TYPES = ["cay", "turkKahvesi", "filtreKahve", "espresso"];

export const productNames = {
  cay: "Çay",
  turkKahvesi: "Türk Kahvesi",
  filtreKahve: "Filtre Kahve",
  espresso: "Espresso",
};

export const defaultMachinePrices = {
  cay: "55000",
  turkKahvesi: "76400",
  filtreKahve: "9000",
  espresso: "200000",
};

export const okkaliUnitPrices = {
  cay: "4.22",
  turkKahvesi: "12",
  filtreKahve: "17",
  espresso: "20",
};

export const machineModelOptions = {
  cay: ["Çayset", "Çayset-Fincanda"],
  filtreKahve: ["Çayset", "Çayset-Fincanda"],
  turkKahvesi: ["Fincanda", "Çayset-Fincanda"],
  espresso: ["Espresso"],
};

// Step'ler
export const STEPS = {
  CONFIG: 1, // ürün seçimi + anlaşma
  CALCULATION: 2,
  PDF: 3,
};
